import { IAppAction, ActionType } from "./../actions/Helpers";
import { IUtility } from "../state/Utility";

// const mosaicLayout: IMosaicNode | null = JSON.parse(localStorage.getItem("mosaic-layout"));

const initialState: IUtility = {
  alert: undefined,
  spinner: undefined,
  theme: "darkTheme", //'lightTheme'
  displayUID: false,
};

export const UtilityReducer = (state: IUtility = initialState, action: IAppAction): IUtility => {
  switch (action.type) {
    case ActionType.OPEN_ALERT:
      return { ...state, alert: action.payload };
    case ActionType.CLOSE_ALERT:
      return { ...state, alert: undefined };
    case ActionType.OPEN_SPINNER:
      return { ...state, spinner: action.payload };
    case ActionType.CLOSE_SPINNER:
      return { ...state, alert: undefined };
    case ActionType.SET_THEME:
      // const themeFile = (action.payload == 'dark') ? 'darkTheme' : 'lightTheme';
      return { ...state, theme: action.payload };
    case ActionType.TOGGLE_UIDS:
      return { ...state, displayUID: action.payload };
    default:
      return state;
  }
};
